module.exports = __webpack_public_path__ + "img/video-camera.f4b8a776.svg";